export default [
	{
		path: '/',
		lazy: async () => {
			const Module = await import('../pages/Home/HomePage');
			return { Component: Module.default };
		},
	},
	{
		path: '/website_entertainments/:websiteEntertainmentId/home',
		lazy: async () => {
			const Module = await import('../pages/Home/HomePage');
			return { Component: Module.default };
		},
	},
];
